import { ReactComponent as Account } from './svg/account.svg';
import { ReactComponent as ArrowSolid } from './svg/arrow-solid.svg';
import { ReactComponent as Arrow } from './svg/arrow.svg';
import { ReactComponent as ArrowBold } from './svg/arrow-bold.svg';
import { ReactComponent as Box } from './svg/box.svg';
import { ReactComponent as Chevron } from './svg/chevron.svg';
import { ReactComponent as Close } from './svg/close.svg';
import { ReactComponent as Dashboard } from './svg/dashboard.svg';
import { ReactComponent as Explore } from './svg/explore.svg';
import { ReactComponent as Fire } from './svg/fire.svg';
import { ReactComponent as Gift } from './svg/gift.svg';
import { ReactComponent as HamburgerMenu } from './svg/hamburger-menu.svg';
import { ReactComponent as Heart } from './svg/heart.svg';
import { ReactComponent as HeartOutline } from './svg/heart-outline.svg';
import { ReactComponent as HeartBig } from './svg/heart-big.svg';
import { ReactComponent as Help } from './svg/help.svg';
import { ReactComponent as Home } from './svg/home.svg';
import { ReactComponent as Info } from './svg/info.svg';
import { ReactComponent as Info2 } from './svg/info2.svg';
import { ReactComponent as Instagram } from './svg/instagram.svg';
import { ReactComponent as Jaaq } from './svg/jaaq.svg';
import { ReactComponent as Logo } from './svg/logo-white.svg';
import { ReactComponent as Menu } from './svg/menu.svg';
import { ReactComponent as NextSlide } from './svg/next.svg';
import { ReactComponent as Options } from './svg/options.svg';
import { ReactComponent as Plus } from './svg/plus.svg';
import { ReactComponent as Privacy } from './svg/privacy.svg';
import { ReactComponent as PrevSlide } from './svg/prev.svg';
import { ReactComponent as Phone } from './svg/phone.svg';
import { ReactComponent as Question } from './svg/question.svg';
import { ReactComponent as Recommended } from './svg/recommended.svg';
import { ReactComponent as Rss } from './svg/rss.svg';
import { ReactComponent as Saved } from './svg/saved.svg';
import { ReactComponent as Scroll } from './svg/scroll.svg';
import { ReactComponent as Search } from './svg/search.svg';
import { ReactComponent as Support } from './svg/support.svg';
import { ReactComponent as User } from './svg/user.svg';
import { ReactComponent as Tedtalk } from './svg/tedtalk.svg';
import { ReactComponent as Tiktok } from './svg/tiktok.svg';
import { ReactComponent as Twitter } from './svg/twitter.svg';
import { ReactComponent as Youtube } from './svg/yt.svg';
import { ReactComponent as YoutubeMin } from './svg/yt-short.svg';
import { ReactComponent as Web } from './svg/web.svg';

export const Icon = {
  Account,
  ArrowSolid,
  Arrow,
  ArrowBold,
  Box,
  Chevron,
  Close,
  Dashboard,
  Explore,
  Fire,
  Gift,
  HamburgerMenu,
  Help,
  Home,
  Info,
  Info2,
  Instagram,
  Jaaq,
  Heart,
  HeartOutline,
  HeartBig,
  Logo,
  Menu,
  NextSlide,
  Options,
  Plus,
  Privacy,
  PrevSlide,
  Phone,
  Question,
  Recommended,
  Rss,
  Saved,
  Scroll,
  Search,
  Support,
  User,
  Tedtalk,
  Tiktok,
  Twitter,
  Youtube,
  YoutubeMin,
  Web,
};
